import { Provider } from 'mobx-react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import AppStore from 'stores/AppStore';
import AppContainer from 'containers';
import ZendeskWidget from 'components/ZendeskWidget';

import 'App.css';
document.title = 'Jitsu Tracking';

// Don't show Zendesk widget on webview routes (they're already inside Zendesk)
const isZendeskWebview = window.location.pathname.startsWith('/zendesk/');

function App() {
  return (
    <div className="App">
      <Provider store={new AppStore()}>
        <BrowserRouter>
          <AppContainer />
          <ToastContainer />
          {!isZendeskWebview && <ZendeskWidget />}
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
